/*
  V18 DATEPICKER FOR NORMAL CART
 */

 
//console.log("Entro");
var $j = jQuery.noConflict();
const numWeeksTwo = 2;
const d = new Date();
  d.setDate(d.getDate() + numWeeksTwo * 7)
  console.log("fecha real" + d);
  
function getDaysAvailable() {
  //const d = new Date();
  
  
  console.log("----------DAY AVAILABLE TEST--------------");
  console.log(d);
  console.log("------------------------");
  //console.log(d.getDay());
  var day = d.getDay();
  //var day = 0;
  if (day == 0) {
    //Domingo
    console.log("Domingo-->Viernes");
    day = 5;
  } else if (day == 1) {
    // Lunes
    console.log("Lunes-->Viernes");
    day = 4;
  } else if (day == 2) {
    // Martes
    console.log("Martes-->Viernes");
    day = 3;
  } else if (day == 3) {
    // Miercoles
    console.log("Miercoles-->Martes");
    day = 6;
  } else if (day == 4) {
    // Jueves
    console.log("Jueves-->Martes");
    day = 5;
  } else if (day == 5) {
    // Viernes
    console.log("Viernes-->Martes");
    day = 4;
  } else if (day == 6) {
    // Sabado
    console.log("Sabado-->Miercoles");
    day = 4;
  }
  return day;
}

/* function getNextDayAvailable() {
  const numWeeks = 3;
  var d = new Date();
  d.setDate(d.getDate() + numWeeks * 7)
  console.log("fecha real" + d);
  let NDate = new Date();
  console.log("----------NEXT DAY AVAILABLE--------------");
  console.log(d);
  console.log("------------------------");
  var day = d.getDay();
  //var day = 0;
  if (day == 0) {
    //Domingo
    console.log("Domingo-->Viernes");
    //day = 5;
    NDate = d.next().friday();
  } else if (day == 1) {
    // Lunes
    console.log("Lunes-->Viernes");
    //day = 4;
    NDate = d.next().friday();
  } else if (day == 2) {
    // Martes
    console.log("Martes-->Viernes");
    //day = 3;
    NDate = d.next().friday();
  } else if (day == 3) {
    // Miercoles
    console.log("Miercoles-->Martes");
    NDate = d.next().tuesday();
    //day = 6;
  } else if (day == 4) {
    // Jueves
    console.log("Jueves-->Martes");
    //day = 5;
    NDate = d.next().tuesday();
  } else if (day == 5) {
    // Viernes
    console.log("Viernes-->Martes");
    //day = 4;
    NDate = d.next().tuesday();
  } else if (day == 6) {
    // Sabado
    console.log("Sabado-->Miercoles");
    //day = 4;
    NDate = d.next().wednesday();
  }
  return NDate;
}
*/
    //const fromDatetwo = day;
    function getNextDayAvailable() {
      //const numWeeks = 3;
  const day = new Date();
  day.setDate(day.getDate() + numWeeks * 7)
    console.log(day);

      
      let NDate = new Date();
      console.log("----------DAY AVAILABLE tres--------------");
      console.log(day);
      console.log("------------------------");
      if (day == 0) {
        //Domingo
        console.log("Domingo-->Viernes");
        //day = 5;
        NDate = d.monday();
      } else if (day == 1) {
        // Lunes
        console.log("Lunes-->Viernes");
        //day = 4;
        NDate = d.tuesday();
      } else if (day == 2) {
        // Martes
        console.log("Martes-->Viernes");
        //day = 3;
        NDate = d.tuesday();
      } else if (day == 3) {
        // Miercoles
        console.log("Miercoles-->Martes");
        NDate = d.wednesday();
        //day = 6;
      } else if (day == 4) {
        // Jueves
        console.log("Jueves-->Martes");
        //day = 5;
        NDate = d.thursday();
      } else if (day == 5) {
        // Viernes
        console.log("Viernes-->Martes");
        //day = 4;
        NDate = d.friday();
      } else if (day == 6) {
        // Sabado
        console.log("Sabado-->Miercoles");
        //day = 4;
        NDate = d.saturday();
      }
      return NDate;
    }

//var minDateDays = 3;
var minDateDays = getDaysAvailable();
console.log("min date ==>" + minDateDays)
//var maxDateEnabled = new Date();
//var minDateDays = getNextDayAvailable();

//https://www.opm.gov/policy-data-oversight/pay-leave/federal-holidays/#url=2022
$j(function () {
  $j("#datepicker")
    .datepicker({
      //dateFormat: 'yy-mm-dd',
      dateFormat: "mm-dd-yy",
        minDate: d,
      maxDate: "+24M",
      beforeShowDay: function (date) {
        var holidays = [
          "2023-11-21",
"2023-11-22",
"2023-11-23",
"2023-11-24",
"2023-12-19",
"2023-12-20",
"2023-12-21",
"2023-12-22",
"2023-12-26",
"2024-01-02",
"2024-02-01",
"2024-02-02",
"2024-02-06",
"2024-02-07",
"2024-02-08",
"2024-02-09",
"2024-02-13",
"2024-02-14",
"2024-02-15",
"2024-04-02",
"2024-04-03",
"2024-05-01",
"2024-05-02",
"2024-05-03",
"2024-05-07",
"2024-05-08",
"2024-05-09",
"2024-05-10",
"2024-07-04",
"2024-07-05",
"2024-11-26",
"2024-11-27",
"2024-11-28",
"2024-11-29",
"2024-12-17",
"2024-12-18",
"2024-12-19",
"2024-12-20",
"2024-12-24",
"2024-12-25",
"2024-12-31",
"2025-01-01",
"2025-01-02",
"2025-01-03",
"2025-02-04",
"2025-02-05",
"2025-02-06",
"2025-02-07",
"2025-02-11",
"2025-02-12",
"2025-02-13",
"2025-02-14",
"2025-04-22",
"2025-05-01",
"2025-05-02",
"2025-05-06",
"2025-05-07",
"2025-05-08",
"2025-05-09",
"2025-07-04",
"2025-11-24",
"2025-11-25",
"2025-11-26",
"2025-11-27",
"2025-11-28",
"2025-12-16",
"2025-12-17",
"2025-12-18",
"2025-12-19",
"2025-12-23",
"2025-12-24",
"2025-12-25",
"2025-12-26",
"2025-12-31"
        ];
        var datestring = jQuery.datepicker.formatDate("yy-mm-dd", date);
        var goodDays = [ 2,3, 4, 5];
        var notHoliday = holidays.indexOf(datestring) == -1;
        return [goodDays.includes(date.getDay()) && notHoliday, ""];
      },
      onSelect: function () {
        var minDate = getDaysAvailable();
        //const d = new Date();
        //var minDate = d;
        //minDateDays.setDate(minDate.getDate()+2); //add two days
        //$j(this).datepicker( "option", "minDate", minDate);
        $j(this).change();
      }, gotoCurrent: true,
      beforeShow: function () {
            setTimeout(function () {
              $j(".ui-datepicker").css("z-index", 9999);
              console.log("Entro Date Picker");
            }, 0);
          },
    })
    .on("change", function () {
      //console.log("Cambio la fecha");
      //actualizar los atributos del carrito para el delivery date
      var deliverydat = document.getElementById("datepicker").value;
      var nullHash = {
        deliverydate: deliverydat,
      };
      $j.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { attributes: nullHash },
        dataType: "json",
      });
    });
});
